import { instance } from "../index";

// Request password reset
export const requestPasswordReset = async (email) => {
  try {
    const response = await instance.post("/api/password-reset/request", {
      email,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Network error" };
  }
};

// Verify reset token
export const verifyResetToken = async (token, email) => {
  try {
    const response = await instance.get("/api/password-reset/verify", {
      params: { token, email },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Network error" };
  }
};

// Reset password
export const resetPassword = async (token, resetCode, email, newPassword) => {
  try {
    const payload = {
      email,
      newPassword,
    };

    // Use either token or resetCode
    if (token) {
      payload.token = token;
    } else if (resetCode) {
      payload.resetCode = resetCode;
    }

    const response = await instance.post("/api/password-reset/reset", payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Network error" };
  }
};

// Get reset status
export const getResetStatus = async (resetId) => {
  try {
    const response = await instance.get(
      `/api/password-reset/status/${resetId}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Network error" };
  }
};

// Cancel reset request
export const cancelResetRequest = async (resetId, email) => {
  try {
    const response = await instance.post("/api/password-reset/cancel", {
      resetId,
      email,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Network error" };
  }
};

// Health check
export const passwordResetHealthCheck = async () => {
  try {
    const response = await instance.get("/api/password-reset/health");
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Network error" };
  }
};
